import { useEffect, useState } from "react";
import AOS from 'aos';
import CustomerLoginButton from "./CustomerLoginButton";
import { Link } from 'react-router-dom';

export default function Home() {

    useEffect(() => {
        AOS.init({
            duration: 1000
        });
    }, []);

    return (

        <>
            <div className='h-20'></div>

            <section className='min-h-screen hero flex items-center'>
                <div className="container px-6 lg:px-0 xl:w-4/5 2xl:container mx-auto">
                    <div className='grid grid-cols-12'>
                        <div className="col-span-12 md:col-span-8 lg:col-span-6 xl:col-span-5 flex flex-col justify-center align-start">
                            <div className='flex flex-col align-start' data-aos={"fade-up"}>
                                <h2 className='heading1 text-start'>Get Out of Debt</h2>
                                <div className='flex justify-start'>
                                    <p className='heading2'>Stress-Free</p>
                                </div>
                                <div className='border-b-4 border-green-500 w-1/5 md:w-52  pt-4'></div>
                                <p className='text-white bannertext mt-10 mr-20  text-start'>
                                    IARC is a debt resolution platform that puts the customer first. Our goal is to put the customer first, and to take the worry and stress out of the debt resolution process
                                </p>
                            </div>
                            <CustomerLoginButton styling={'bg-white text-black mt-8'} />
                        </div>
                    </div>
                    <div className="hidden md:block md:col-span-7 banner">
                    </div>
                </div>
            </section>

            <section className="py-16 sm:py-14">
                <p className="md:text-4xl text-3xl font-bold text-center">IARC is your partner in starting your Repayment Journey</p>
                    <div className="flex mt-9">
                        <div className="flex flex-wrap w-full md:mx-7 mx-2 gap-5 md:justify-between items-center justify-center">
                                <div className="group h-[450px] w-[330px] [perspective:1000px]">
                                    <div className="relative h-full w-full rounded-xl shadow-xl transition-all duration-1000 [transform-style:preserve-3d] ">
                                        
                                        <div className="absolute inset-0 h-full w-full rounded-xl px-6 text-center text-slate-200 border border-gray-200">
                                            <div className="flex justify-center ">
                                                <img src='/assets/map-pin.svg' className= "md:mt-4 w-16 mt-2" />
                                            </div>
                                            <p className="text-xl text-black font-bold mt-2">Start Repaying and Regain Control</p>
                                            <div className="flex flex-col items-center justify-center mt-7">
                                                <div className="flex w-full">
                                                    <div className="relative">
                                                        <span className="absolute left-0 -top-1 bg-[#EBF5FF] w-7 h-7 rounded-full border border-[#1F2A37] text-sm text-[#1F2A37] text-center inline-block">
                                                        <p className="mt-[2px]">1</p>
                                                        </span>

                                                        <div className="absolute left-3 top-7 h-[45px] border-l-2 border-dashed border-gray-400"></div>
                                                    </div>
                                                    <div className="ml-11 w-[100%] text-left -mt-1">
                                                        <p className="text-[#1F2A37] font-semibold text-base md:text-lg">Login to your account</p>
                                                    </div>
                                                </div>

                                                <div className="flex !mt-11 w-full">
                                                    <div className="relative">
                                                        <span className="absolute left-0 -top-1 bg-[#EBF5FF] w-7 h-7 rounded-full border border-[#1F2A37] text-sm text-[#1F2A37] text-center inline-block">
                                                        <p className="mt-[2px]">2</p>
                                                        </span>

                                                        <div className="absolute left-3 top-7 h-[45px] border-l-2 border-dashed border-gray-400"></div>
                                                    </div>
                                                    <div className="ml-11 w-[100%] text-left">
                                                        <p className="text-[#1F2A37] font-semibold text-base -mt-1 md:text-lg">Confirm Account Details</p>
                                                    </div>
                                                </div>

                                                <div className="flex mt-11 w-full">
                                                    <div className="relative">
                                                        <span className="absolute left-0 -top-1 bg-[#EBF5FF] w-7 h-7 rounded-full border border-[#1F2A37] text-sm text-[#1F2A37] text-center">
                                                            <p className="mt-[2px]">3</p>
                                                        </span>
                                                    </div>
                                                    <div className="ml-11 w-[100%] text-left">
                                                        <p className="text-[#1F2A37] font-semibold text-base -mt-1 md:text-lg">Start Payment Journey</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="absolute bottom-6 left-6 right-6">
                                                <Link to='https://res.iarc.co.in/login' target='_blank'>
                                                    <button className="w-full bg-[#3F83F8] text-[16px] font-medium text-white p-2 rounded-md">Sign up</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* second card */}
                                <div className="group h-[450px] w-[330px] [perspective:1000px]">
                                    <div className="relative h-full w-full rounded-xl shadow-xl transition-all duration-1000 [transform-style:preserve-3d]">
                                        
                                        <div className="absolute inset-0 h-full w-full rounded-xl px-6 text-center text-slate-200 border border-gray-200">
                                            <div className="flex justify-center">
                                                <img src='/assets/headset.svg' className="w-16 mt-4"/>
                                                
                                            </div>
                                            <div className="mt-4">
                                                <h1 className="text-black font-bold text-xl">We’re Here to Help You Take the Next Step</h1>
                                                <p className="mt-4 text-black text-sm text-left leading-6">We’re reaching out because we want to support you in managing your outstanding obligations. 
                                                </p>
                                                <p className=" text-black text-sm text-left leading-6">
                                                    Our goal is to provide you with the resources and guidance needed to start your repayment journey smoothly. 
                                                </p>
                                                <p className=" text-black text-sm text-left leading-6">
                                                    You can call us on <b>011-41199445</b> or write to us at <b>customersupport@iarc.co.in</b>
                                                </p>
                                            </div>
                                            <div className="absolute bottom-6 left-6 right-6">
                                                <a href='https://wa.me/+918657050390?text=Yes' target='_blank'>
                                                    <button className="w-full bg-[#3F83F8] text-[16px] font-medium text-white p-2 rounded-md">WhatsApp Us</button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Third Card */}

                                <div className="group h-[450px] w-[330px] [perspective:1000px]">
                                    <div className="relative h-full w-full rounded-xl shadow-xl transition-all duration-1000 [transform-style:preserve-3d]">
                                        
                                        <div className="absolute inset-0 h-full w-full rounded-xl px-6 text-center text-slate-200 border border-gray-200">
                                            <div className="flex justify-center">
                                                <img src='/assets/Vector.svg' className="w-16 md:w-11 mt-3 md:mt-6"/>
                                            </div>
                                            <div className="mt-4">
                                                <h1 className="text-black font-bold text-xl">Clear Guidance, Real Solutions</h1>
                                                <div className="text-black mt-4">
                                                    <p className="font-bold text-sm text-left">We’ll Understand Your Situation</p>
                                                    <p className="text-left text-sm mt-1">We’ll listen to your needs and offer personalized advice.</p>
                                                    <p className="font-bold text-sm text-left mt-2"> We’ll Explore Repayment Options</p>
                                                    <p className="text-left text-sm mt-1">We’ll walk you through the available plans suited to your situation.</p>
                                                    <p className="font-bold text-sm text-left mt-2">We'll Guide you to the next step together.</p>
                                                    <p className="text-sm text-left mt-1">Together, we’ll finalize your repayment plan and get you started.</p>
                                                </div>
                                            </div>
                                            <div className="absolute bottom-6 left-6 right-6">
                                                <a href={`tel:01141199445`} target='_blank'>
                                                    <button className="w-full bg-[#3F83F8] text-[16px] font-medium text-white p-2 rounded-md">
                                                        Call Us
                                                    </button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* fourth card */}

                                <div className="group h-[450px] w-[330px] [perspective:1000px]">
                                    <div className="relative h-full w-full rounded-xl shadow-xl transition-all duration-1000 [transform-style:preserve-3d]">
                                        
                                        <div className="absolute inset-0 h-full w-full rounded-xl px-5 text-center text-slate-200 border border-gray-200">
                                            <div className="flex justify-center">
                                                <img src='/assets/user-round-search.svg' className="w-16 mt-2"/>
                                            </div>
                                            <div className="mt-2">
                                                <h1 className="text-black font-bold text-lg">Have questions or need assistance with your repayment? </h1>
                                                <p className="mt-2 text-black text-sm text-left leading-7">
                                                    Our team is ready to help. Contact us via phone, email, or through your account portal, and we’ll provide the support you need.
                                                </p>
                                                <div className="mt-2">
                                                    <div className='flex items-center'>
                                                        <img src='/assets/phone.svg' />
                                                        <p className="text-black text-sm ml-3 font-bold">011-41199445</p>
                                                    </div>
                                                    <div className='flex items-center mt-1'>
                                                        <img src='/assets/whatsapp_icon.svg' />
                                                        <p className="text-black text-sm ml-3 font-bold">+91-8657050390</p>
                                                    </div>
                                                    <div className='flex items-center mt-1'>
                                                        <img src='/assets/mail.svg' />
                                                        <p className="text-black text-sm ml-3 font-bold">customersupport@iarc.co.in</p>
                                                    </div>
                                                    <div className='flex items-center mt-1'>
                                                         <img src='/assets/globe.svg' />
                                                         <p className="text-black text-sm ml-3 font-bold">res.iarc.co.in</p>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            <div className="absolute bottom-6 left-6 right-6">
                                                <Link to='https://res.iarc.co.in/login' target='_blank'>
                                                    <button className="w-full bg-[#3F83F8] text-[16px] font-medium text-white p-2 rounded-md">Customer Log In</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
            </section>


            <section className='min-h-screen'>
                <div className='container px-6 lg:px-0 xl:w-4/5 2xl:container mx-auto min-h-screen py-10 lg:py-0'>
                    <div className='grid grid-cols-11 min-h-screen'>
                        <div className='col-span-11 take lg:col-span-5 flex items-end lg:min-h-screen justify-center'>
                            <img
                                src='/assets/shutterstock_1725877684 1.png'
                                className='w-2/4 lg:w-full mx-auto'
                                alt='Resolve your debt'
                            />
                        </div>
                        <div className='hidden lg:block lg:col-span-1'></div>
                        <div className='col-span-11 lg:col-span-5 flex items-center lg:min-h-screen'>
                            <div data-aos={"fade-up"}>
                                <p className='text-black font-bold put text-[40px] text-start'>Customized Debt Relief</p>
                                <p className='text-black font-bold put text-[40px] text-start'>Solutions</p>
                                <div className='border-b-4 border-green-500 w-1/5 md:w-52 pt-4'></div>
                                <div className='flex justify-center'>
                                    <p className='text-black with text-base mt-5 mb-5 md:mt-10 text-start'>
                                    Debt settlement is possible! At IARC, we help you live a debt-free life with our flexible and convenient payment plans customized to your unique needs.
                                    </p>
                                </div>
                                <CustomerLoginButton styling={'bg-black text-white mt-6'} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='newsec min-h-screen w-full flex items-center'>
                <div className='container px-6 lg:px-0 xl:w-4/5 2xl:container mx-auto'>
                    <div className="grid grid-cols-12">
                        <div className="col-span-12 md:col-span-8 lg:col-span-6 xl:col-span-5 flex flex-col justify-center align-start" data-aos={"fade-up"}>
                            <div className='flex flex-col align-start'>
                                <h2 className='heading1 text-start'>Put Yourself Back</h2>
                                <div className='flex justify-start'>
                                    <p className='heading2'>in Control</p>
                                </div>
                                <div className='border-b-4 border-green-500 w-1/5 md:w-52 pt-4'></div>
                                <p className='text-white bannertext mt-10 mr-20 text-start'>
                                    With IARC, the resolution of debt can be simple and straightforward. We provide you with the tools and resources you need to regain control of your finances, repair your credit score, and improve your creditworthiness.
                                </p>
                            </div>
                            <CustomerLoginButton styling={'bg-white text-black mt-8'} />
                        </div>
                    </div>
                </div>
            </section>

            <section className='min-h-screen flex items-center'>
                <div className='container px-6 lg:px-0 xl:w-4/5 2xl:container mx-auto'>
                    <div className='grid grid-cols-11'>
                        <div className='col-span-11 take lg:col-span-4 xl:col-span-5 lg:px-6 2xl:px-0 flex items-center justify-center'>
                            <img src='/assets/home3.png' className='w-3/4 md:w-2/4 lg:w-full 2xl:w-3/4 mx-auto h-auto' alt='Customer-Centered Debt Resolution' />
                        </div>
                        <div className='lg:col-span-1'></div>
                        <div className='col-span-11 lg:col-span-6 xl:col-span-5 flex flex-col items-center' data-aos={"fade-up"}>
                            <div className='mt-20'>
                                <p className='text-black font-bold put text-[40px] text-start'>Revolutionary Digital Platform for Convenient Debt Management</p>
                                <div className='border-b-4 border-green-500 w-1/5 md:w-52 pt-4'></div>
                                <div className='flex justify-center'>
                                    <p className='text-black with text-base mt-4 md:mt-10 text-start mb-10'>Our revolutionary platform provides comprehensive debt management solutions tailored to your unique needs, no matter where you are in the debt resolution process. With our user-friendly interface and easy-to-use tools, managing your debt has never been simpler. Experience the convenience of managing your debt at your fingertips with our innovative digital platform.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}